import type { IValidationResult, IValidatorParams } from "@edaz/services/baseValidationService";
import { formatDate } from "utils/localizations";

export interface IsDateRangeOptions {
  min?: Date;
  max?: Date;
}
export interface DateRange {
  from?: Date;
  to?: Date;
}
// eslint-disable-next-line sonarjs/cognitive-complexity
export default function isDateRange(
  value?: DateRange,
  options?: IsDateRangeOptions,
  params?: IValidatorParams
): IValidationResult {
  if (options?.min !== undefined && options.max !== undefined && options.min > options.max) {
    throw new Error("Given options interval is invalid");
  }

  if (value) {
    if (value.from !== undefined && value.to !== undefined && value.from > value.to) {
      return {
        isValid: false,
        errors: {
          constraints: {
            isInterval: "false",
          },
        },
      };
    }

    if (
      options?.min !== undefined &&
      ((value.from !== undefined && value.from < options.min) ||
        (value.from === undefined && value.to !== undefined && value.to < options.min))
    ) {
      return {
        isValid: false,
        errors: {
          constraints: {
            minimum: "false",
          },
          params: [`${formatDate(options.min)}`],
        },
      };
    }

    if (
      options?.max !== undefined &&
      ((value.to !== undefined && value.to > options.max) ||
        (value.to === undefined && value.from !== undefined && value.from > options.max))
    ) {
      return {
        isValid: false,
        errors: {
          constraints: {
            maximum: "false",
          },
          params: [`${formatDate(options.max)}`],
        },
      };
    }
  }

  return {
    isValid: true,
  };
}
